// extracted by css-extract-rspack-plugin
var _1 = "E_hBrQhR83wd7NI7";
var _2 = "yRr7dDDrYEDmsVtm";
export { _1 as "laOptions", _2 as "laOptionsCollapsed" }
